<template>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>RELATÓRIO PSICOLÓGICO - Conceito e finalidade&nbsp;</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Estrutura</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 1º O relatório psicológico deve apresentar as informações da estrutura detalhada abaixo, em&nbsp;forma&nbsp;de&nbsp;itens&nbsp;ou&nbsp;texto&nbsp;corrido.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">O&nbsp;relatório&nbsp;psicológico&nbsp;é&nbsp;composto&nbsp;de&nbsp;5&nbsp;(cinco)&nbsp;itens:</span></span>
      </p>
    </li>
  </ol>
  <ol style="list-style-type: lower-latin">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Identificação;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Descrição&nbsp;da&nbsp;demanda;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Procedimento;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Análise;</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Conclusão.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Identificação</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§&nbsp;2º&nbsp;Neste&nbsp;item,&nbsp;a(o)&nbsp;psicóloga(o)&nbsp;deve&nbsp;fazer&nbsp;constar&nbsp;no&nbsp;documento:</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"
          ><span lang="PT" dir="ltr">-&nbsp;Título:&nbsp;<strong>"Relatório&nbsp;Psicológico";</strong></span></span
        >
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">-&nbsp;Nome&nbsp;da&nbsp;pessoa&nbsp;ou&nbsp;instituição&nbsp;atendida:&nbsp;identificação&nbsp;do&nbsp;nome&nbsp;completo&nbsp;ou&nbsp;nome&nbsp;social&nbsp;completo&nbsp;e, quando&nbsp;necessário, outras&nbsp;informações sócio-demográficas;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Nome do solicitante: identificação de quem solicitou o documento, especificando se a&nbsp;solicitação&nbsp;foi&nbsp;realizada&nbsp;pelo&nbsp;Poder&nbsp;Judiciário,&nbsp;por&nbsp;empresas,&nbsp;instituições&nbsp;públicas&nbsp;ou&nbsp;privadas,&nbsp;pelo&nbsp;próprio&nbsp;usuário&nbsp;do&nbsp;processo&nbsp;de&nbsp;trabalho&nbsp;prestado&nbsp;ou&nbsp;por&nbsp;outros&nbsp;interessados;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Finalidade:&nbsp;descrição&nbsp;da&nbsp;razão&nbsp;ou&nbsp;motivo&nbsp;do&nbsp;pedido;</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">-&nbsp;Nome&nbsp;da(o)&nbsp;autora(or):&nbsp;identificação&nbsp;do&nbsp;nome&nbsp;completo&nbsp;ou&nbsp;nome&nbsp;social&nbsp;completo&nbsp;da(o)&nbsp;psicóloga(o) responsável pela construção do documento, com a respectiva inscrição no&nbsp;Conselho&nbsp;Regional de Psicologia.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Descrição&nbsp;da&nbsp;demanda</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§3º Neste item, a(o) psicóloga(o), autora(or) do documento, deve descrever as informações&nbsp;sobre&nbsp;o&nbsp;que&nbsp;motivou&nbsp;a&nbsp;busca&nbsp;pelo&nbsp;processo&nbsp;de&nbsp;trabalho&nbsp;prestado,&nbsp;indicando&nbsp;quem&nbsp;forneceu&nbsp;as&nbsp;informações&nbsp;e as&nbsp;demandas&nbsp;que levaram&nbsp;à&nbsp;solicitação&nbsp;do&nbsp;documento.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">A descrição da demanda constitui requisito indispensável e deverá apresentar o raciocínio&nbsp;técnico-científico que justificará procedimentos utilizados, conforme o parágrafo 4º deste&nbsp;artigo.</span></span>
      </p>
    </li>
  </ol>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Procedimento</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 4º Neste item, a(o) psicóloga(o) autora(or) do relatório deve apresentar o raciocínio técnico-&nbsp;científico&nbsp;que&nbsp;justifica&nbsp;o&nbsp;processo&nbsp;de&nbsp;trabalho&nbsp;utilizado&nbsp;na&nbsp;prestação&nbsp;do&nbsp;serviço&nbsp;psicológico&nbsp;e&nbsp;os&nbsp;recursos técnico-científicos utilizados, especificando o referencial teórico metodológico que&nbsp;fundamentou&nbsp;suas&nbsp;análises, interpretações e&nbsp;conclusões.</strong></span></span
    >
  </p>

  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Cumpre,&nbsp;à(ao)&nbsp;psicóloga(o)&nbsp;autora(or)&nbsp;do&nbsp;relatório,&nbsp;citar&nbsp;as&nbsp;pessoas&nbsp;ouvidas&nbsp;no&nbsp;processo&nbsp;de&nbsp;trabalho desenvolvido, as informações objetivas, o número de encontros e o tempo de&nbsp;duração&nbsp;do&nbsp;processo&nbsp;realizado.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Os procedimentos adotados devem ser pertinentes à complexidade do que esta´ sendo&nbsp;demandado.</span></span>
      </p>
    </li>
  </ol>

  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Análise</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 5º Neste item devem constar, de forma descritiva, narrativa e analítica, as principais&nbsp;características e evolução do trabalho realizado, baseando-se em um pensamento sistêmico&nbsp;sobre os dados colhidos e as situações relacionadas à demanda que envolve o processo de&nbsp;atendimento&nbsp;ou&nbsp;acolhimento,&nbsp;sem&nbsp;que&nbsp;isso&nbsp;corresponda&nbsp;a&nbsp;uma&nbsp;descrição&nbsp;literal&nbsp;das&nbsp;sessões, atendimento ou acolhimento, salvo quando tal descrição se justificar tecnicamente.&nbsp;</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">A&nbsp;análise deve&nbsp;apresentar&nbsp;fundamentação&nbsp;teórica&nbsp;e&nbsp;técnica.</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">Somente deve ser relatado o que for necessário para responder a demanda, tal qual&nbsp;disposto&nbsp;no&nbsp;Código&nbsp;de&nbsp;Ética&nbsp;Profissional do&nbsp;Psicólogo.</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">É vedado à(ao) psicóloga(o) fazer constar no documento afirmações de qualquer ordem&nbsp;sem&nbsp;identificação&nbsp;da&nbsp;fonte&nbsp;de&nbsp;informação&nbsp;ou&nbsp;sem&nbsp;a&nbsp;devida&nbsp;sustentação&nbsp;em&nbsp;fatos&nbsp;e/ou&nbsp;teorias.</span></span>
      </p>
    </li>
    <li>
      <p style="margin-left: 5pt; text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">A linguagem deve ser objetiva e precisa, especialmente quando se referir a informações de&nbsp;natureza&nbsp;subjetiva.</span></span>
      </p>
    </li>
  </ol>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>Conclusão</strong></span></span
    >
  </p>
  <p style="margin-left: 5pt; text-align: justify">
    <span style="font-family: Calibri, sans-serif; font-size: 11pt"
      ><span lang="PT" dir="ltr"><strong>§ 6º Neste item, a(o) psicóloga(o) autora(or) do relatório deve descrever suas conclusões, a&nbsp;partir do que foi relatado na análise, considerando a natureza dinâmica e não cristalizada do&nbsp;seu&nbsp;objeto&nbsp;de&nbsp;estudo.</strong></span></span
    >
  </p>
  <ol style="list-style-type: upper-roman">
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- Na conclusão pode constar encaminhamento, orientação e sugestão de continuidade do&nbsp;atendimento&nbsp;ou&nbsp;acolhimento.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: Calibri, sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">- O documento deve ser encerrado com indicação do local, data de emissão, carimbo, em&nbsp;que conste nome completo ou nome social completo da(o) psicóloga(o), acrescido de sua&nbsp;inscrição&nbsp;profissional,&nbsp;com&nbsp;todas&nbsp;as&nbsp;laudas&nbsp;numeradas,&nbsp;rubricadas&nbsp;da&nbsp;primeira&nbsp;até&nbsp;a&nbsp;penúltima&nbsp;lauda,&nbsp;e a&nbsp;assinatura&nbsp;da(o)&nbsp;psicóloga(o)&nbsp;na&nbsp;última&nbsp;página.</span></span>
      </p>
    </li>
    <li>
      <p style="text-align: justify">
        <span style="font-family: 'Calibri', sans-serif; font-size: 11pt"><span lang="PT" dir="ltr">É facultado à(ao) psicóloga(o) destacar, ao final do relatório, que este não poderá ser&nbsp;utilizado para fins diferentes do apontado no item de identificação, que possui caráter sigiloso,&nbsp;que se trata de documento extrajudicial e que não se responsabiliza pelo uso dado ao relatório&nbsp;por&nbsp;parte&nbsp;da&nbsp;pessoa,&nbsp;grupo&nbsp;ou&nbsp;instituição,&nbsp;após&nbsp;a&nbsp;sua&nbsp;entrega&nbsp;em&nbsp;entrevista&nbsp;devolutiva.</span></span>
      </p>
    </li>
  </ol>
</template>
